import { request } from './api-request';

export const getClothesByBarcode = async (barcode) => {
    const safe = encodeURIComponent(barcode);
    try {
        const response = await request('GET', `Clothes/ByBarcode/${safe}`);
        return response.data;
    } catch (err) {
        // Fallback to alternate casing used locally
        if (err?.response?.status === 404) {
            const alt = await request('GET', `Clothes/Bybarcode/${safe}`);
            return alt.data;
        }
        throw err;
    }
};

export default { getClothesByBarcode };

